import React from 'react';
import { DatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';

const ProYearPicker: React.FC<DatePickerProps> = React.forwardRef<
  any,
  DatePickerProps
>((props, ref) => {
  return (
    <DatePicker picker='year' ref={ref} {...props} />
  );
});

export default ProYearPicker;
